/** Nuestra ancla (Who) — foto en estudio, primer plano. */
export const YERALDIN_MARRERO_ANCHOR_SRC = '/images/talent/yeraldinmarrero.jpg';

/** Sección final (AreYouReady) — foto anterior en set TNO. */
export const YERALDIN_MARRERO_PORTRAIT_SRC = '/images/talent/yeraldinmarrero-studio.jpg';

export const TNO_SPORTS_LOGO_SRC = 'https://files.tnonetwork.com/shows/logo/tnosports.png';
